import React, { useState, useContext } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
// Config
import { ConfigContext } from '../../../../providers';
// Styles
import styles from './footerlinks.module.scss';
import { cn } from '../../../../helpers';
import { CustomLink } from '../../..';

interface IFooterLinkProps {
    isCentered: boolean;
    isInline: boolean;
}

const FooterLinks = ({ isCentered, isInline }: IFooterLinkProps): JSX.Element => {
    const [isOpened, setIsOpened] = useState<boolean>(false);
    const { links, colors } = useContext(ConfigContext);
    const { formatMessage } = useIntl();

    const footerLinksClasses = cn(styles.links, {
        'd-flex justify-content-center': isCentered,
    });
    const dropdownClasses = cn(styles.dropdown, {
        [styles.hiddenDropdown]: !isOpened,
        [styles.inLineDropdown]: isInline,
        'd-flex justify-content-center': isInline,
    });

    const toggle = (): void => {
        setIsOpened((prev) => !prev);
    };

    return (
        <div role="button" className={footerLinksClasses} onClick={toggle}>
            <span className={styles.dropdownLabel}>
                <FormattedMessage id="MORE" />
            </span>
            <div className={dropdownClasses} style={{ backgroundColor: colors.header.background }}>
                <CustomLink
                    href={formatMessage({ id: 'FOOTER_TERMS_OF_USE_SITE_LINK' })}
                    target="_blank"
                    variant="light"
                >
                    <FormattedMessage id={links.footer.termsOfUse.label} />
                </CustomLink>
                <CustomLink
                    href={formatMessage({ id: 'FOOTER_PRIVACY_POLICY_SITE_LINK' })}
                    target="_blank"
                    variant="light"
                >
                    <FormattedMessage id={links.footer.privacyPolicy.label} />
                </CustomLink>
                <CustomLink href={links.footer.cookies.link} target="_blank" variant="light">
                    <FormattedMessage id={links.footer.cookies.label} />
                </CustomLink>
                <CustomLink href={links.footer.contact.link} target="_blank" variant="light">
                    <FormattedMessage id={links.footer.contact.label} />
                </CustomLink>
            </div>
        </div>
    );
};

export default FooterLinks;
